import "core-js/modules/es.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React from 'react';
import { compose } from 'recompose';
import SvgIcon from 'wfui-digital-core/es/SvgIcon';
import useBrand from 'wfui-digital-core/es/useBrand';
import accessibleIcon from 'wfui-digital-core/es/accessibleIcon';

var ProfileIcon = function ProfileIcon(props) {
  var brand = useBrand();
  var fillColor = brand === 'tpb' ? '#c4af93' : '#ffe6a0';
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    viewBox: "0 0 64 64"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path-1",
    cx: "27.5087719",
    cy: "28",
    rx: "27.5087719",
    ry: "28"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: fillColor,
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 9.000000)",
    id: "WF_icon_customer_service-(2)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeWidth: ".4",
    d: "M41.5822865,48.0245655 C41.2515886,48.5105875 40.6562302,48.8693333 40.0728555,48.8693333 L3.93308954,48.8693333\n                  C3.34971487,48.8693333 2.79942983,48.5608047 2.4232053,48.0240194 C2.03247573,47.4664835 1.87609324,46.7352979\n                  1.99394671,46.0194021 C2.54423175,42.675279 4.01875995,39.5048056 6.25842912,36.850913 C7.77420604,35.05544 9.62178579,33.6820779\n                  11.8832125,32.6811344 C15.2553546,31.505267 18.6276171,30.9173333 22,30.9173333 C26.1038844,30.9173333 29.4779775,31.505267\n                  32.1222793,32.6811344 C34.383706,33.6820779 36.231739,35.05544 37.747516,36.850913 C39.9867319,39.5048056 41.4612601,42.6747329\n                  42.0119984,46.0194021 C42.1298518,46.7352979 41.9129844,47.5385434 41.5822865,48.0245655 Z M43.9225956,45.3553978 C43.2945815,41.7083018\n                  41.6295089,38.2691953 39.1066169,35.4114194 C35.9381029,31.8230804 31.5889586,29.8107819 25.4180767,29.0786588 C24.5859919,28.9798638\n                  23.3403478,28.9231866 22.0003436,28.9226667 C20.6598879,28.9231866 19.4142439,28.9798638 18.582159,29.0786588 C12.4112772,29.8113018\n                  8.06168133,31.8230804 4.89361884,35.4114194 C2.37072684,38.2697152 0.705202753,41.7083018 0.0776401395,45.3553978 C-0.160743357,46.7380081\n                  0.155746853,48.1497369 0.945392185,49.2281625 C1.70704552,50.2675901 2.82085628,50.864 4.00193815,50.864 L39.9982976,50.864 C41.1793795,50.864\n                  42.2931902,50.2675901 43.0543921,49.2281625 C43.8440374,48.1502569 44.1605276,46.7385281 43.9225956,45.3553978 Z M21.5111111,1.99466667\n                  C27.4419117,1.99466667 32.2666667,6.91591676 32.2666667,12.9653333 C32.2666667,19.0142939 27.4419117,23.936 21.5111111,23.936 C15.5803105,23.936\n                  10.7555556,19.0142939 10.7555556,12.9653333 C10.7555556,6.91591676 15.5803105,1.99466667 21.5111111,1.99466667 Z M34.2222222,12.9653333\n                  C34.2222222,5.8161946 28.5196256,0 21.5111111,0 C14.5021516,0 8.8,5.8161946 8.8,12.9653333 C8.8,20.1144721 14.5021516,25.9306667 21.5111111,25.9306667\n                  C28.5196256,25.9306667 34.2222222,20.1144721 34.2222222,12.9653333 Z",
    fill: "#3B3331"
  })))))));
};

ProfileIcon.defaultProps = {
  width: '64px',
  height: '64px'
};
export default /*#__PURE__*/React.memo(compose(accessibleIcon)(ProfileIcon));